import React from 'react';
import './App.scss';
import Layout from './Layout/Layout';
import HomePage from './pages/HomePage';

const App = () => {
  return (
    <div className="App">
      <Layout>
        <HomePage></HomePage>
      </Layout>
    </div>
  );
};

export default App;
